import { Component, OnInit } from '@angular/core';

@Component
({
  selector: 'organization.detail.page',
  templateUrl: './organization.detail.page.html',
  styleUrls: ['./organization.detail.page.scss']
})

export class OrganizationDetailPage implements OnInit 
{
  //-------------------------------------------------------------------------
  
  constructor
  () {}

  //-------------------------------------------------------------------------

  ngOnInit(): void {}

  //-------------------------------------------------------------------------

  //funzione che riceve
}
